import classNames from 'classnames';
import * as React from 'react';

import { getTranslation, keys } from '../../../../../../Resources/Translations';
import { DiscountType } from '../../../../../Blocks/DiscountType.csharp';
import { AppliedFreeItemPromotionViewModel } from '../../../../../Catalog/Product/Promotion/AppliedFreeItemPromotionViewModel.csharp';
import { PriceDisplay } from '../../../../../ReactComponents/PriceDisplay';
import { CartItemViewModel } from '../../ViewModels/CartItemViewModel.csharp';

interface CheckoutItemPriceProps {
    item: CartItemViewModel;
    showQuantity?: boolean;
    isQuantityLoaderActive: boolean;
}

export const CheckoutItemPrice = (props: CheckoutItemPriceProps) => {
    const cheapestForFreeDiscounts = props.item.appliedDiscounts.filter((p) => p.discountType == DiscountType.CheapestForFree);
    const appliedCheapestForFreePromotion = cheapestForFreeDiscounts.length == 1 && (cheapestForFreeDiscounts[0] as AppliedFreeItemPromotionViewModel);

    const currentQuantity = props.item.quantityOrdered - props.item.quantityCancelled;

    const freeQuantity = (appliedCheapestForFreePromotion && appliedCheapestForFreePromotion.numberOfFreeItems) || 0;
    const chargedQuantity = freeQuantity ? currentQuantity - freeQuantity : currentQuantity;
    const allItemsFree = currentQuantity <= freeQuantity && props.item.discountedPrice === 0;

    const priceBefore = (currentQuantity * Math.floor(props.item.placedPrice * 100)) / 100;

    let discountedPricePerItem = allItemsFree
        ? 0
        : freeQuantity
        ? props.item.discountedPrice / (currentQuantity - freeQuantity)
        : props.item.discountedPrice / currentQuantity;

    const isDiscountedPriceCorrect = discountedPricePerItem <= props.item.placedPrice || allItemsFree;
    discountedPricePerItem = isDiscountedPriceCorrect ? discountedPricePerItem : props.item.discountedPrice / currentQuantity;
    const shouldRenderQuantity =
        props.showQuantity && ((!!discountedPricePerItem && !!currentQuantity) || (props.item.isReplacement && currentQuantity > 1) || allItemsFree);

    const renderChargedQuantity = () => {
        return (
            shouldRenderQuantity &&
            (chargedQuantity > 0 || !allItemsFree) && (
                <span className="CartItem__OrderedQuantity">
                    {isDiscountedPriceCorrect ? chargedQuantity : currentQuantity} x {<PriceDisplay price={discountedPricePerItem} />}
                </span>
            )
        );
    };
    const renderFreeQuantity = () => {
        return (
            shouldRenderQuantity &&
            (freeQuantity > 0 || allItemsFree) &&
            isDiscountedPriceCorrect && (
                <span className="CartItem__OrderedQuantity">
                    {allItemsFree ? currentQuantity : freeQuantity} x <PriceDisplay price={0} />
                </span>
            )
        );
    };
    const renderOriginalPrice = () => {
        return (
            !props.item.isReplacement &&
            priceBefore > props.item.discountedPrice && (
                <span className="CartItem__PriceBefore CartItem__PriceBefore--Checkout">
                    <span className="CartItem__PriceBeforeLabel">{getTranslation(keys['orderSummary.before'])}</span>
                    :&nbsp;
                    <PriceDisplay price={priceBefore} />
                </span>
            )
        );
    };

    const renderPrice = () => {
        return (
            <div className={classNames('CartItem__Price', props.isQuantityLoaderActive && 'CartItem__Price--Disabled')}>
                <span className="CartItem__PriceTotal CartItem__PriceTotal--Checkout" tabIndex={0}>
                    {props.item.isReplacement && props.item.discountedPrice === 0 ? (
                        getTranslation(keys['orderSummary.replacement'])
                    ) : (
                        <PriceDisplay price={props.item.discountedPrice} />
                    )}
                </span>
            </div>
        );
    };

    return (
        <div className={classNames('CartItem__Pricing', 'CartItem__Pricing--Checkout', props.showQuantity && 'CartItem__Pricing--WithQuantity')}>
            <div className="CartItem_PriceWrapper CartItem_PriceWrapper--Checkout">
                {renderChargedQuantity()}
                {renderFreeQuantity()}
            </div>
            {renderOriginalPrice()}
            {!props.item.isReplacement && props.item.appliedDiscounts?.length > 0 && (
                <div className="CartItem__Discount CartItem__Discount--Checkout">{props.item.appliedDiscounts.map((d) => d.mainInfo).join(', ')}</div>
            )}
            {renderPrice()}
        </div>
    );
};
